import React, { useEffect, useState } from "react";
import {
  UploadOutlined,
  FilePdfOutlined,
  DeleteOutlined,
  FileWordOutlined,
} from "@ant-design/icons";
import { Button, Col, Modal, Popover, Space, Upload } from "antd";
import { ServerAPI } from "../../common/ServerAPI";
import { IMAGE_BASE_URL } from "../../common/Constants";
import { checkValidations, reverseObject } from "../../common/Utilities";
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const FileUploadWithThumbnails = ({
  label,
  maxfile,
  size,
  datakey,
  dataApiKey,
  updateFunction,
  guarantor,
  files,
  onRetrive,
}) => {
  const [fileList, setFileList] = useState([]);
  const [defaultList, setDefaultList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [previewType, setPreviewType] = useState("");

  const onChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const handleRemove = (fileToRemove) => {
    onRemoveRequest(fileToRemove);
    setFileList((prevList) => prevList.filter((file) => file.uid !== fileToRemove.uid));
  };

  const onRemoveRequest = (file) => {
    setDefaultList((prevDefaultList) => {
      const updatedDefaultList = prevDefaultList.filter(
        (image) => image.name !== file.name
      );
      let updatedUrl = [];
      if (datakey == "vehicle_details") {
        let savedValues = localStorage.getItem("vehicleDocuments");
        const parsedValues = savedValues ? JSON.parse(savedValues) : {};
        updatedDefaultList.map((list) => {
          if (list.url != undefined) {
            const parts = list.url.split("/api/");
            const valueAfterApi = parts[1];
            updatedUrl.push({
              name: list.name,
              value: valueAfterApi,
            });
          } else {
            updatedUrl.push({
              name: list.name,
              value: list.value,
            });
          }
        });
        parsedValues[dataApiKey] = updatedUrl;
        localStorage.setItem("vehicleDocuments", JSON.stringify(parsedValues));
      }
      if (datakey == "applicant_documents") {
        let savedValues = localStorage.getItem("applicant_documents");
        const parsedValues = savedValues ? JSON.parse(savedValues) : {};
        updatedDefaultList.map((list) => {
          if (list.url != undefined) {
            const parts = list.url.split("/api/");
            const valueAfterApi = parts[1];
            updatedUrl.push({
              name: list.name,
              value: valueAfterApi,
            });
          } else {
            updatedUrl.push({
              name: list.name,
              value: list.value,
            });
          }
        });

        parsedValues[dataApiKey] = updatedUrl;

        localStorage.setItem(
          "applicant_documents",
          JSON.stringify(parsedValues)
        );
      }
      if (datakey == "guarantor_documents") {
        let savedValues = localStorage.getItem(
          "guarantor_documents_" + guarantor
        );
        const parsedValues = savedValues ? JSON.parse(savedValues) : {};
        updatedDefaultList.map((list) => {
          if (list.url != undefined) {
            const parts = list.url.split("/api/");
            const valueAfterApi = parts[1];
            updatedUrl.push({
              name: list.name,
              value: valueAfterApi,
            });
          } else {
            updatedUrl.push({
              name: list.name,
              value: list.value,
            });
          }
        });
        parsedValues[dataApiKey] = updatedUrl;
        localStorage.setItem(
          "guarantor_documents_" + guarantor,
          JSON.stringify(parsedValues)
        );
      }
      if (datakey == "disbursement_docs") {
        let savedValues = localStorage.getItem("disbursementDocuments");
        const parsedValues = savedValues ? JSON.parse(savedValues) : {};
        updatedDefaultList.map((list) => {
          if (list.url != undefined) {
            const parts = list.url.split("/api/");
            const valueAfterApi = parts[1];
            updatedUrl.push({
              name: list.name,
              value: valueAfterApi,
            });
          } else {
            updatedUrl.push({
              name: list.name,
              value: list.value,
            });
          }
        });
        parsedValues[dataApiKey] = updatedUrl;
        localStorage.setItem(
          "disbursementDocuments",
          JSON.stringify(parsedValues)
        );
      }
      return updatedDefaultList;
    });
  };

  // Custom request to control file upload
  const customUploadRequest = async ({ file, onSuccess, onError }) => {
    if (
      onRetrive !== undefined &&
      onRetrive !== null &&
      dataApiKey === "log_card"
    ) {
      onRetrive(file);
    }
    // Perform your custom file upload logic here
    try {
      const response = await ServerAPI.fileUpload(file);
      if (response.resp_code == 200) {
        if (response.data && datakey == "vehicle_details") {
          let savedValues = localStorage.getItem("vehicleDocuments");
          const parsedValues = savedValues ? JSON.parse(savedValues) : {};
          if (parsedValues[dataApiKey]) {
            if (parsedValues[dataApiKey].value) {
              parsedValues[dataApiKey].value.push({
                name: file.name,
                value: response.data,
              });
            } else {
              parsedValues[dataApiKey].push({
                name: file.name,
                value: response.data,
              });
            }
          } else {
            parsedValues[dataApiKey] = [
              {
                name: file.name,
                value: response.data,
              },
            ];
          }
          setDefaultList(parsedValues[dataApiKey]);
          localStorage.setItem(
            "vehicleDocuments",
            JSON.stringify(parsedValues)
          );
        } else if (response.data && datakey == "applicant_documents") {
          const savedValues = localStorage.getItem("applicant_documents");
          const parsedValues = savedValues ? JSON.parse(savedValues) : {};
          if (parsedValues[dataApiKey]) {
            if (parsedValues[dataApiKey].value) {
              parsedValues[dataApiKey].value.push({
                name: file.name,
                value: response.data,
              });
            } else {
              parsedValues[dataApiKey].push({
                name: file.name,
                value: response.data,
              });
            }
          } else {
            parsedValues[dataApiKey] = [
              {
                name: file.name,
                value: response.data,
              },
            ];
          }
          setDefaultList(parsedValues[dataApiKey]);
          localStorage.setItem(
            "applicant_documents",
            JSON.stringify(parsedValues)
          );
        } else if (response.data && datakey == "guarantor_documents") {
          const savedValues = localStorage.getItem(
            "guarantor_documents_" + guarantor
          );
          const parsedValues = savedValues ? JSON.parse(savedValues) : {};
          if (parsedValues[dataApiKey]) {
            if (parsedValues[dataApiKey].value) {
              parsedValues[dataApiKey].value.push({
                name: file.name,
                value: response.data,
              });
            } else {
              parsedValues[dataApiKey].push({
                name: file.name,
                value: response.data,
              });
            }
          } else {
            parsedValues[dataApiKey] = [
              {
                name: file.name,
                value: response.data,
              },
            ];
          }
          setDefaultList(parsedValues[dataApiKey]);
          localStorage.setItem(
            "guarantor_documents_" + guarantor,
            JSON.stringify(parsedValues)
          );
        } else if (response.data && datakey == "disbursement_docs") {
          let savedValues = localStorage.getItem("disbursementDocuments");
          const parsedValues = savedValues ? JSON.parse(savedValues) : {};
          if (parsedValues[dataApiKey]) {
            if (parsedValues[dataApiKey].value) {
              parsedValues[dataApiKey].value.push({
                name: file.name,
                value: response.data,
              });
            } else {
              parsedValues[dataApiKey].push({
                name: file.name,
                value: response.data,
              });
            }
          } else {
            parsedValues[dataApiKey] = [
              {
                name: file.name,
                value: response.data,
              },
            ];
          }
          setDefaultList(parsedValues[dataApiKey]);
          localStorage.setItem(
            "disbursementDocuments",
            JSON.stringify(parsedValues)
          );
        }
        onSuccess();
      }
    } catch (error) {
      // On error, call the onError callback
      onError(error);
    }
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    const extension = file.name.split(".").pop().toLowerCase();
    if (extension === "pdf" || extension === "doc" || extension === "docx") {
      setPreviewType("doc");
    } else {
      setPreviewType("img");
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const iconMap = {
    pdf: <FilePdfOutlined />,
    docx: <FileWordOutlined />,
  };

  // useEffect(() => {
  //   let savedValues = {};
  //   if (datakey == "applicant_documents") {
  //     savedValues = localStorage.getItem("applicant_documents");
  //   } else if (datakey == "vehicle_details") {
  //     savedValues = localStorage.getItem("vehicleDocuments");
  //   } else if (datakey == "guarantor_documents") {
  //     savedValues = localStorage.getItem("guarantor_documents_" + guarantor);
  //     console.log("savedValues============", JSON.parse(savedValues))
  //   } else if (datakey == "disbursement_docs") {
  //     savedValues = localStorage.getItem("disbursementDocuments");
  //   }

  //   if (savedValues && Object.keys(savedValues).length != 0) {
  //     let parsedValues = JSON.parse(savedValues);
  //     if (dataApiKey && parsedValues[dataApiKey]) {
  //       let imageUrlArrays = [];
  //       if (parsedValues[dataApiKey].value) {
  //         parsedValues[dataApiKey].value.map((url, idx) => {
  //           imageUrlArrays.push({
  //             uid: idx + 1,
  //             disabled: url.disabled,
  //             name: url.name ? url.name : url?.split("/").pop(),
  //             status: "done",
  //             url: url.value
  //               ? IMAGE_BASE_URL + "/" + url.value
  //               : IMAGE_BASE_URL + "/" + url,
  //           });
  //         });
  //       } else {
  //         parsedValues[dataApiKey].map((url, idx) => {
  //           imageUrlArrays.push({
  //             uid: idx + 1,
  //             disabled: url.disabled,
  //             name: url.name ? url.name : url?.split("/").pop(),
  //             status: "done",
  //             url: url.value
  //               ? IMAGE_BASE_URL + "/" + url.value
  //               : IMAGE_BASE_URL + "/" + url,
  //           });
  //         });
  //       }
  //       setFileList(imageUrlArrays);
  //       setDefaultList(imageUrlArrays);
  //     }
  //   }
  // }, [datakey, dataApiKey, guarantor, files]);

  useEffect(() => {
    let savedValues = {};
    if (datakey == "applicant_documents") {
      savedValues = localStorage.getItem("applicant_documents");
    } else if (datakey == "vehicle_details") {
      savedValues = localStorage.getItem("vehicleDocuments");
    } else if (datakey == "guarantor_documents") {
      savedValues = localStorage.getItem("guarantor_documents_" + guarantor);
    } else if (datakey == "disbursement_docs") {
      savedValues = localStorage.getItem("disbursementDocuments");
    }

    const updateFromStorage = (savedValues) => {
      if (savedValues && Object.keys(savedValues).length != 0) {
        let parsedValues = JSON.parse(savedValues);
        if (dataApiKey && parsedValues[dataApiKey]) {
          let imageUrlArrays = [];
          const docs = parsedValues[dataApiKey].value
            ? parsedValues[dataApiKey].value
            : parsedValues[dataApiKey];
          docs.map((url, idx) => {
            imageUrlArrays.push({
              uid: idx + 1,
              disabled: url.disabled,
              name: url.name ? url.name : url?.split("/").pop(),
              status: "done",
              url: url.value
                ? IMAGE_BASE_URL + "/" + url.value
                : IMAGE_BASE_URL + "/" + url,
            });
          });
          setFileList(imageUrlArrays);
          setDefaultList(imageUrlArrays);
        }
      }
    };
    updateFromStorage(savedValues);
    // (for SingPass case)
    if (datakey === "guarantor_documents") {
      const storageKey = "guarantor_documents_" + guarantor;
      const interval = setInterval(() => {
        const newSaved = localStorage.getItem(storageKey);
        if (newSaved) {
          const parsed = JSON.parse(newSaved);
          if (parsed && Object.keys(parsed).length > 0) {
            const currentFileNames = fileList.map((f) => f.name);
            const hasNewFile = Object.values(parsed).some((arr) =>
              arr.some((doc) => !currentFileNames.includes(doc.name))
            );
            if (hasNewFile) {
              updateFromStorage(newSaved);
              clearInterval(interval);
            }
          }
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [datakey, dataApiKey, guarantor, files]);


  const getIcon = (file) => {
    if (file.name) {
      const extension = file.name.split(".").pop().toLowerCase();
      return iconMap[extension];
    }
  };
  const uploadProps = {
    iconRender: (file, listType) => {
      return getIcon(file);
    },
  };
  useEffect(() => {
    if (files !== undefined && files !== null) {
      const FileArrray = fileList?.concat(files);
      const ids = FileArrray.map(({ uid }) => uid);
      const filtered = FileArrray.filter(
        ({ uid }, index) => !ids.includes(uid, index + 1)
      );
      setFileList(filtered);
    }
  }, [files]);

  return (
    <Col xs={24} sm={12} md={8} lg={7} className="mb-5">
      <div className="flex flex-wrap">
        <div className="w-full sm:w-2/2 lg:w-4/4 mt-1 text-[12px] font-semibold">
          <p>
            {label}
            <Popover content={"Coming soon"} className="mt-[-4px]">
              <img
                src="/images/fi_info.svg"
                alt="info"
                className="inline-block ml-[8px] cursor-pointer"
              />
            </Popover>
          </p>
        </div>
      </div>
      <Modal
        open={previewOpen}
        title={previewTitle}
        centered
        footer={null}
        onCancel={() => setPreviewOpen(false)}
        width={"80%"}
      >
        {previewType === "img" ? (
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewImage}
          />
        ) : (
          <iframe src={previewImage} className="w-full" height={800} />
        )}
      </Modal>
      <Upload
        {...uploadProps}
        customRequest={customUploadRequest}
        listType="picture"
        multiple
        maxCount={maxfile}
        style={{ width: "100%" }}
        onChange={onChange}
        fileList={fileList}
        className="uploadCard"
        onRemove={onRemoveRequest}
        onPreview={handlePreview}
        itemRender={(originNode, file, currFileList) => {
          return (
            <div
              style={{
                border: '1px solid #e5e5e5',
                borderRadius: 8,
                padding: 12,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                maxWidth: 400,
                backgroundColor: '#fff',
                marginBottom: 12, // <--- This adds space between items
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handlePreview(file)}>
                <FilePdfOutlined style={{ fontSize: 32, color: '#1677ff', marginRight: 8 }} />
                <span style={{ fontWeight: 500 }}>{file.name}</span>
              </div>
              <DeleteOutlined
                style={{ color: file.disabled == true ? '#ccc' : '#999', fontSize: 18, cursor: file.disabled == true ? 'not-allowed' : 'pointer' }}
                onClick={() => file.disabled != true ? handleRemove(file) : null}
              />
            </div>
          );
        }}
        accept=".png,.jpeg,.jpg,.docx,.doc,.pdf"
      >
        <div className="grid grid-cols-2 gap-4 w-full mt-5">
          <div className="py-4 mt-[-20px]">
            {" "}
            <p className="text-left font-lato text-[13px] text-[400] text-instruction-grey opacity-60">
              Max {maxfile} Files{" "}
            </p>
          </div>
          <div className="p-4  mt-[-27px] upload-btn text-end">
            <Button
              className="border-0 shadow-none text-step-color-active"
              disabled={fileList.length == maxfile ? true : false}
            >
              <div className="flex">
                <UploadOutlined className="mt-1 mr-2" />
                <span>Upload</span>
              </div>
            </Button>
          </div>
        </div>
      </Upload>
    </Col>
  );
};

export default FileUploadWithThumbnails;
